<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="grey darken-3"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Peoplecourseweekregistrations") }} {{ $t("ofCourses") }}
        </div>
      </template>
      <v-row class="mb-1">
        <v-col class="text-right">
          <v-btn target="_blank" :href="'/export/payments?token=' + this.token"
            >Export</v-btn
          >
        </v-col>
      </v-row>
      <advanced-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        sort-by="created_at"
        :sort-desc="true"
        class="elevation-1"
        :filterCols="filterCols"
        :filters="filters"
        v-on:filter="
          filters = $event;
          getData();
        "
        v-model="selection"
        show-select
        @click:row="(event, row) => row.select(!row.isSelected)"
        @contextmenu:row="onContextClick"
      >
        <template v-slot:item.courseWeek.course.name="{ item }">
          {{ item.courseWeek.course.name }}
        </template>
        <template v-slot:item.payed_amount="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="green" v-bind="attrs" v-on="on" v-if="item.payed">
                mdi-check
              </v-icon>
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                v-else-if="!item.payed && item.payed_amount !== null"
              >
                mdi-exclamation
              </v-icon>
              <v-icon color="red" dark v-bind="attrs" v-on="on" v-else>
                mdi-close
              </v-icon>
            </template>
            <span v-if="item.payed_amount">{{
              item.payed_amount | currency
            }}</span>
            <span v-else>0 €</span> /
            <span v-if="item.day_type == 'full_day'">{{
              item.courseWeek.price | currency
            }}</span>
            <span v-else>{{ item.courseWeek.price_half_day | currency }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.day_type="{ item }">
          <template v-if="item.day_type == 'half_day'">
            {{
              $i18n.locale == "de"
                ? item.courseWeek.course.label_half_day_de
                : item.courseWeek.course.label_half_day_it
            }}
          </template>
          <template v-else>
            {{
              $i18n.locale == "de"
                ? item.courseWeek.course.label_full_day_de
                : item.courseWeek.course.label_full_day_it
            }}
          </template>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | formatDateTime }}
        </template>
        <template v-slot:item.is_waiting="{ item }">
          <span v-if="item.is_waiting">{{ $t("yes") }}</span>
          <span v-else>{{ $t("no") }}</span>
        </template>
        <template v-slot:item.photo_privacy="{ item }">
          <span v-if="item.photo_privacy == 1">{{ $t("yes") }}</span>
          <span v-else-if="item.photo_privacy == 0">{{ $t("no") }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:item.courseWeek.course.name="{ item }">
          <a
            @click="
              $router.push({
                path: '/be/course/' + item.courseWeek.course.id + '/show'
              })
            "
            v-if="item.courseWeek.course.name"
            >{{ item.courseWeek.course.name }}</a
          >
        </template>
        <template v-slot:item.courseWeek.name="{ item }">
          {{ item.courseWeek.name }}
          <v-chip small
            >{{ item.courseWeek.from | formatDate }}-{{
              item.courseWeek.to | formatDate
            }}</v-chip
          >
          <v-tooltip bottom v-if="item.custom_field">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" color="red" dark v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>{{ $t("custom_field") }}: {{ item.custom_field }}</span>
            <span v-if="item.custom_field_2"> | {{ $t("custom_field_2") }}: {{ item.custom_field_2 }}</span>
            <span v-if="item.custom_field_3"> | {{ $t("custom_field_3") }}: {{ item.custom_field_3 }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon @click="sendRegistrationEmail(item)" class="mr-2" color="red" dark>
            mdi-email
          </v-icon>
          <v-tooltip bottom v-if="item.comment_internal">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" color="red" dark v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>{{ item.comment_internal }}</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.comment">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                color="secondary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-information
              </v-icon>
            </template>
            <span>{{ item.comment }}</span>
          </v-tooltip>
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </advanced-data-table>
      <v-menu
        v-model="selectionMenu.show"
        :position-x="selectionMenu.x"
        :position-y="selectionMenu.y"
        close-on-content-click
        close-on-click
        absolute
        offset-y
      >
        <v-list link>
          <v-list-item link @click="openPaymentDialog">
            <v-list-item-title
              ><v-icon>mdi-cash-multiple</v-icon> Bezahlungen
              einbuchen</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <v-dialog v-model="paymentDialog" max-width="800">
        <v-card>
          <v-card-title>Bezahlungen einbuchen</v-card-title>
          <v-card-text>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Bezahlt</th>
                  <th>Offen</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in selectionNonWaiting" :key="item.id">
                  <td>
                    {{ item.people.first_name }} {{ item.people.last_name }}
                  </td>
                  <td>
                    <span v-if="item.payed_amount">{{
                      item.payed_amount | currency
                    }}</span>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <span v-if="item.day_type == 'full_day'">{{
                      (item.courseWeek.price - item.payed_amount) | currency
                    }}</span>
                    <span v-else>{{
                      (item.courseWeek.price_half_day - item.payed_amount)
                        | currency
                    }}</span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td><strong>Gesamt</strong></td>
                  <td></td>
                  <td>
                    <strong>{{ selectionSum | currency }}</strong>
                  </td>
                </tr>
              </tfoot>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="paymentDialog = false">{{ $t("close") }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="selectionSum == 0"
              color="primary"
              @click="savePayments()"
              >{{ $t("book_open_payments") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem, savePayments, resendEmail } from "../shared/services";

export default {
  name: "app-peopleCourseWeekRegistration-list",
  data() {
    return {
      loading: true,
      options: {},
      total: 0,
      search: "",
      items: [],
      filters: [],
      selection: [],
      selectionMenu: {
        show: false,
        x: 0,
        y: 0
      },
      paymentDialog: false,
      token: "",
      currentRequestId: 0,
    };
  },

  mounted() {
    this.token = localStorage.getItem("laravel-vue-spa");
  },
  created() {
    this.filters = ["courseWeek.course.active|1"];
    this.getData();
  },

  methods: {
    async getData() {
      this.currentRequestId++;
      const requestId = this.currentRequestId;

      this.loading = true;
      let response = await fetchItems({
        ...this.options,
        search: this.search,
        filters: this.filters
      });
      if (requestId === this.currentRequestId) { 
        this.items = response.data;
        this.total = response.meta.total;
        this.loading = false;
      }
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Peoplecourseweekregistration?")+' ['+item.people.first_name+' '+item.people.last_name+']'
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    async onContextClick(e, row) {
      e.preventDefault();
      if (this.selection.length <= 1) {
        row.select(true);
      }
      this.selectionMenu.show = false;
      this.selectionMenu.x = e.clientX;
      this.selectionMenu.y = e.clientY;
      await this.$nextTick();
      this.selectionMenu.show = true;
    },
    openPaymentDialog() {
      this.paymentDialog = true;
    },
    async savePayments() {
      let ids = this.selectionNonWaiting.map(function(a) {
        return a.id;
      });
      let resp = await savePayments({ data: ids });
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.paymentDialog = false;
        this.selection = [];
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({
        name: "peopleCourseWeekRegistration.edit",
        params: { id: url }
      });
    },
    async sendRegistrationEmail(item) {
      if (
        await this.$root.$confirm(
          this.$t("Confirm"),
          this.$t("Are you sure to re-send Registration Email for Registration ")+item.people.first_name+" "+item.people.last_name+""
        )
      ) {
        let resp = await resendEmail({ id: item.id });
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
      }


    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler: _.debounce(function () {
        this.getData();
      }, 300), // 300ms debounce delay
      immediate: false,
    },
  },
  computed: {
    filterCols() {
      return [
        {
          title: this.$t("first_name"),
          name: "people.first_name",
          type: "text"
        },
        {
          title: this.$t("last_name"),
          name: "people.last_name",
          type: "text"
        },
        {
          title: this.$t("tax"),
          name: "people.tax",
          type: "text"
        },
        {
          title: this.$t("Course") + " " + this.$t("name"),
          name: "courseWeek.course.name",
          type: "text"
        },
        {
          title: this.$t("CourseWeek") + " " + this.$t("name"),
          name: "courseWeek.name",
          type: "text"
        },
        {
          title: this.$t("day_type"),
          name: "day_type",
          type: "select",
          props: {
            itemText: "name",
            itemValue: "id"
          },
          items: [
            {
              id: "full_day",
              name: this.$t("full_day")
            },
            {
              id: "half_day",
              name: this.$t("half_day")
            }
          ]
        },
        {
          title: this.$t("waiting_list"),
          name: "is_waiting",
          type: "select",
          props: {
            itemText: "name",
            itemValue: "id"
          },
          items: [
            {
              id: 0,
              name: this.$t("no")
            },
            {
              id: 1,
              name: this.$t("yes")
            }
          ]
        },
        {
          title: this.$t("year"),
          name: "courseWeek.course.from",
          type: "select",
          props: {
            itemText: "name",
            itemValue: "id"
          },
          items: [
            {
              id: "2022",
              name: "2022"
            },
            {
              id: "2023",
              name: "2023"
            },
            {
              id: "2024",
              name: "2024"
            },
            {
              id: "2025",
              name: "2025"
            }
          ]
        },
        {
          title: this.$t("course") + " " + this.$t("active"),
          name: "courseWeek.course.active",
          type: "select",
          props: {
            itemText: "name",
            itemValue: "id"
          },
          items: [
            {
              id: 1,
              name: this.$t("yes")
            },
            {
              id: 0,
              name: this.$t("no")
            }
          ]
        }
      ];
    },
    headers() {
      let headers = [
        {
          text: this.$t("date"),
          align: "left",
          value: "created_at"
        },
        {
          text: this.$t("first_name"),
          align: "left",
          value: "people.first_name"
        },
        {
          text: this.$t("last_name"),
          align: "left",
          value: "people.last_name"
        },
        {
          text: this.$t("tax"),
          align: "left",
          value: "people.tax"
        },
        {
          text: this.$t("Course") + " " + this.$t("name"),
          align: "left",
          value: "courseWeek.course.name"
        },
        {
          text: this.$t("CourseWeeks"),
          align: "left",
          value: "courseWeek.name"
        },
        {
          text: this.$t("day_type"),
          align: "left",
          value: "day_type"
        },
        {
          text: this.$t("payed"),
          align: "left",
          value: "payed_amount"
        },
        {
          text: this.$t("waiting_list"),
          align: "left",
          value: "is_waiting"
        },
        { text: "", value: "action", sortable: false }
      ];
      if (
        this.$store.state.modules.options.photo_privacy &&
        this.$store.state.modules.options.photo_privacy == 1
      ) {
        headers = [
          {
            text: this.$t("date"),
            align: "left",
            value: "created_at"
          },
          {
            text: this.$t("first_name"),
            align: "left",
            value: "people.first_name"
          },
          {
            text: this.$t("last_name"),
            align: "left",
            value: "people.last_name"
          },
          {
            text: this.$t("tax"),
            align: "left",
            value: "people.tax"
          },
          {
            text: this.$t("Course") + " " + this.$t("name"),
            align: "left",
            value: "courseWeek.course.name"
          },
          {
            text: this.$t("CourseWeeks"),
            align: "left",
            value: "courseWeek.name"
          },
          {
            text: this.$t("day_type"),
            align: "left",
            value: "day_type"
          },
          {
            text: this.$t("payed"),
            align: "left",
            value: "payed_amount"
          },
          {
            text: this.$t("waiting_list"),
            align: "left",
            value: "is_waiting"
          },
          {
            text: this.$t("photo_privacy_header"),
            align: "left",
            value: "photo_privacy"
          },
          { text: "", value: "action", sortable: false }
        ];
      }
      return headers;
    },
    selectionNonWaiting(){
      return this.selection.filter(item => {
        return item.is_waiting == false;
      })
    },
    selectionSum() {
      let sum = 0;
      this.selectionNonWaiting.forEach(function(item) {
        let currentAmount = 0;
        if (item.day_type == "full_day") {
          currentAmount = item.courseWeek.price;
        } else {
          currentAmount = item.courseWeek.price_half_day;
        }
        sum = sum + currentAmount - item.payed_amount;
      });
      return sum;
    }
  }
};
</script>

<style lang="scss" scoped></style>
